export default __webpack_public_path__ + "static/media/value-proposition.7c966e49.svg";